import { useState } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { useDispatch } from 'react-redux';
import { visualizerActions } from './store';

import LandingPage from './components/LandingPage/LandingPage';
import VisualizerPage from './components/VisualizerPage/VisualizerPage';
import ChamUpload from './components/ChamUpload/ChamUpload';
import ChamProjects from './components/ChamProjects/ChamProjects';
import LoadingScreen from './components/LoadingScreen/LoadingScreen';
import FloorPlansPage from './components/FloorPlansPage/FloorPlansPage';
import LoadingPage from './components/LoadingPage/LoadingPage';
import TestPage from './components/TestPage/TestPage';
import { getAllSheetsFromFile } from './Helpers/SheetsHelper';
import { getJsonBySeriesId } from './Helpers/SheetsHelper';


const router = createBrowserRouter([
  { path: '/', element: <><LandingPage /> <ChamProjects /></>, errorElement: <><h1>ERROR</h1></> },
  { path: '/shared/:code', element: <LoadingPage/> },
  { path: '/floorplans', element: <><FloorPlansPage />  <ChamProjects /></> },
  { path: '/visualizer/floorplan/:floorplan/area/:area/spec/:specifier/sel/:selString', element: <><VisualizerPage /> <ChamProjects /></> },
  { path: '/test', element: <TestPage/> },
])


function App() {

  const [dataReady, setDataReady] = useState(false);
  const dispatch = useDispatch();
    //series ids to store 
    let seriesIds = [8489,8496,8497];
  
  getAllSheetsFromFile('/data/Floorplans.xlsx').then(jsonData => {
    const filteredFloorplanData = jsonData["Floorplans"].filter((floorplan) => floorplan.id !== -1);
    dispatch(visualizerActions.setFloorPlanData(filteredFloorplanData));
    dispatch(visualizerActions.setFloorPlanSteps(jsonData["PlanSteps"]));
    dispatch(visualizerActions.setStepsData(jsonData["Steps"]));

    // setDataReady(true);
  })

    // Fetch and dispatch data for each seriesId
    seriesIds.forEach(seriesId => {
      getJsonBySeriesId(seriesId).then(jsonData => {
        // Use reduce to create an object with ids as keys
        const data = jsonData.reduce((acc, obj) => {
          acc[obj.id] = obj;
          return acc;
        }, {});
    
        dispatch(visualizerActions.setSeriesData({ data, seriesId }));
      });
    });


  return (
    <>
      <div>
        <RouterProvider router={router} />
        <ChamUpload />
        <LoadingScreen />
      </div>
    </>
  );
}

export default App;


